import { render, staticRenderFns } from "./ExportCr.vue?vue&type=template&id=68fa1cc0"
import script from "./ExportCr.vue?vue&type=script&lang=js"
export * from "./ExportCr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports